import React from 'react';
import { StyleSheet } from 'react-native';
import { TextLink, theme } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

export const RequestAccountDeletionTrigger = (
  props: RequestAccountDeletionTriggerProps,
) => {
  const { onRequestAccountDeletion } = props;
  const { t } = useLocalizationContext();

  return (
    <TextLink
      testID="account.delete.trigger"
      style={styles.trigger}
      onPress={onRequestAccountDeletion}
    >
      {t('account.delete.trigger')}
    </TextLink>
  );
};

type RequestAccountDeletionTriggerProps = {
  readonly onRequestAccountDeletion: () => void;
};

const styles = StyleSheet.create({
  trigger: {
    width: '100%',
    textAlign: 'center',
    color: theme.colors.CAUTION,
    marginTop: theme.spacing.xlarge,
  },
});
